import {combineReducers} from "@reduxjs/toolkit";
import {
  commonReducer,
  authReducer,
  patientReducer,
  accountReducer,
  receiveReducer,
  roleFunctionReducer,
  diagnosticExaminationReducer,
  examinationReducer,
  listAssignReducer,
  apiRoleReducer,
  nurseOutReducer,
  pharmacyStoreReducer,
  medicineStoreReducer,
  patientRecordReducer,
  pendingReducer,
  examBtnClickReducer,
  tableAddReducer,
  allocationMedicineReducer,
  residentialNurseReducer,
  diagnoseReducer,
  inventoryReducer,
  medicalSuppliesReducer,
  electrocardiographyReducer,
  receiveReload,
  pgpReducer,
  glassStoreReducer,
  consultantAndFragmentReducer,
  glassKiotReducer,
  employeesReducer,
  customerCareReducer,
  reduxCommonReducer,
  nursingInReducer,
  searchPatientReducer,
  proposeShoppingReducer,
} from "./reducer";

const rootReducer = combineReducers({
  common: commonReducer,
  auth: authReducer,
  patient: patientReducer,
  account: accountReducer,
  receive: receiveReducer,
  glassStoreService: glassStoreReducer,
  roleFunction: roleFunctionReducer,
  diagnosticExamination: diagnosticExaminationReducer,
  examination: examinationReducer,
  listAssign: listAssignReducer,
  apiRole: apiRoleReducer,
  nurseOut: nurseOutReducer,
  pharmacyStore: pharmacyStoreReducer,
  medicineStore: medicineStoreReducer,
  patientRecord: patientRecordReducer,
  pending: pendingReducer,
  examClick: examBtnClickReducer,
  tableAdd: tableAddReducer,
  allocationMedicine: allocationMedicineReducer,
  residentialNurse: residentialNurseReducer,
  diagnose: diagnoseReducer,
  inventory: inventoryReducer,
  medicalSuppliesReducer: medicalSuppliesReducer,
  electrocardiography: electrocardiographyReducer,
  receiveReload: receiveReload,
  pgp: pgpReducer,
  glassStore: glassStoreReducer,
  glassKiot: glassKiotReducer,
  consultantAndFragment: consultantAndFragmentReducer,
  employeesReducer: employeesReducer,
  customerCare: customerCareReducer,
  reduxCommon: reduxCommonReducer,
  nursingIn: nursingInReducer,
  searchPatient: searchPatientReducer,
  proposeShopping: proposeShoppingReducer,
});

export default rootReducer;
